import axios from 'axios';
import { toFromDates, grabMonthsToAndFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_SALES_PERFORMANCE_BY_FILTER,
  REQUEST_SALES_PERFORMANCE_SUCCESS,
  REQUEST_SALES_PERFORMANCE_FAILURE,
  REQUEST_USER_PERFORMANCE_BY_FILTER,
  REQUEST_USER_PERFORMANCE_SUCCESS,
  REQUEST_USER_PERFORMANCE_FAILURE,
} from './type';

import {
  SALES_PERFORMANCE_URL,
  USER_PERFORMANCE_URL,
} from './url';

import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../actions/root_url';

const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
  const isATL = ROOT_API_URL === 'https://alton-scm.truckxi.com/api/' || ROOT_URL === 'https://alton-scm.truckxi.com/api/';

export function fetchSalesPerformanceByFilter(orderType, salesType, days, fromDate, toDate, type, productNum, group, category, aggregate, user, customer) {
  const dates = toFromDates(days, fromDate, toDate);
  if (salesType === 'salesorder') {
    fromDate = `SalesInvoice_id__DispatchDate__gte=${dates.fromDate}`;
    toDate = `SalesInvoice_id__DispatchDate__lte=${dates.toDate}`;
  } else if (salesType === 'posorder') {
    fromDate = `Order_id__Date__gte=${dates.fromDate}`;
    toDate = `Order_id__Date__lte=${dates.toDate}`;
  } else if (salesType === 'all') {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  } else {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  }
  if (productNum) {
    productNum = `&Product_id__ProductNum=${productNum}`;
    group = '';
    category = '';
    aggregate = '';
    user = '';
    customer= '';
  } else {
    productNum = '';
    if (group) {
      group = `&Product_id__ProductGroup_id=${group}`;
    } else {
      group = '';
    }
    if (category) {
      category = `&Product_id__ProductCategory1_id=${category}`;
    } else {
      category = '';
    }
    if (aggregate) {
      aggregate = `&Aggregate=${aggregate}`;
    } else {
      aggregate = '';
    }
    if (user) {
      user = `&Sales_User_id=${user}`;
    } else {
      user = '';
    }
    if (customer) {
      customer = `&SalesInvoice_id__Deliver_Customer_id=${customer}`;
    } else {
      customer = '';
    }
  }
  let belongWarehouse = ``;
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    belongWarehouse = ``;
  } else {
    belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
  }
  if ((isAFM || isATL) && orderType) {
    // orderType = `&order_type=${orderType}`;
    orderType = ``;
  } else {
    orderType = ``;
  }
  return (dispatch) => {
    dispatch({
      type: REQUEST_SALES_PERFORMANCE_BY_FILTER,
      payload: {
        type,
        salesType,
        fromDate,
        toDate,
        productNum,
        group,
        category,
        aggregate,
        user,
        belongWarehouse,
        customer,
        orderType,
      },
    });
  };
}

export const SalesPerformanceListEpic = action$ =>
  action$.ofType(REQUEST_SALES_PERFORMANCE_BY_FILTER)
    .switchMap(action =>
      axios.get(
        `${SALES_PERFORMANCE_URL + action.payload.type}/${action.payload.salesType}/?${action.payload.fromDate
        }&${action.payload.toDate}${action.payload.productNum}${action.payload.group}${action.payload.category
        }${action.payload.aggregate}${action.payload.user}${action.payload.belongWarehouse}${action.payload.orderType}${action.payload.customer}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: REQUEST_SALES_PERFORMANCE_SUCCESS, payload: response }))
    .catch(err => ({ type: REQUEST_SALES_PERFORMANCE_FAILURE, payload: err }));


export function fetchUserPerformanceByFilter(fromDate, toDate, userId, mode, days, lastMonth) {
  let dates;
  if ((days !== -1 || days !== '-1') && !lastMonth) {
    dates = grabMonthsToAndFromDates(days, fromDate, toDate, false);
  } else if ((days !== -1 || days !== '-1') && lastMonth) {
    dates = grabMonthsToAndFromDates(days, fromDate, toDate, lastMonth);
  } else {
    dates = toFromDates(days, fromDate, toDate);
  }
  return (dispatch) => {
    dispatch(requestUserPerformanceByFilter());
    return axios.get(`${USER_PERFORMANCE_URL}`, {
      params: {
        startDate: dates.fromDate,
        endDate: dates.toDate,
        userId,
        mode,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => {
        dispatch(requestUserPerformanceSuccess(response.data));
      }, (err) => {
        dispatch(requestUserPerformanceFailure(err));
      });
  };
}


export function requestUserPerformanceByFilter() {
  return {
    type: REQUEST_USER_PERFORMANCE_BY_FILTER,
  };
}

export function requestUserPerformanceSuccess(response) {
  return {
    type: REQUEST_USER_PERFORMANCE_SUCCESS,
    payload: response,
  };
}

export function requestUserPerformanceFailure(error) {
  return {
    type: REQUEST_USER_PERFORMANCE_FAILURE,
    payload: error,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/salesPerformanceList_actions.js